import {toStringYearFirst} from "../../util/date-utils"
import {ProjectWork} from "../../domain/project-work"
import moment, {Moment} from "moment"
import {HourBooking} from "../../domain/hour-booking"

export interface IHoursApi {
  getProjectWork(projectId: string, date: Date, signal?: AbortSignal): Promise<ProjectWork>
  saveHourBooking(hourBooking: HourBooking): Promise<void>
}

export class HoursApi implements IHoursApi {
  constructor(private baseUrl: string) {
  }

  async getProjectWork(projectId: string, date: Date, signal?: AbortSignal): Promise<ProjectWork> {
    const url = `${this.baseUrl}/projecthours/${projectId}/ForYear/${toStringYearFirst(date)}`
    const response = await fetch(url, {method: "get", signal})
    const projectWork = await response.json()
    if (projectWork.workMonths != null) {
      projectWork.workMonths.forEach((x: { month: string | Moment, workDays: { day: string | Moment }[] }) => {
        x.month = moment(x.month)
        x.workDays.forEach((workDay: { day: moment.MomentInput }) => {
          workDay.day = moment(workDay.day)
        })
      })
    }
    return projectWork
  }

  async saveHourBooking(hourBooking: HourBooking): Promise<void> {
    const url = `${this.baseUrl}/hourbookings`
    await fetch(url, {
      method: hourBooking.id === undefined ? "post": "put",
      body: JSON.stringify(hourBooking),
      headers: {"Content-Type": "application/json"}
    })
  }
}
